export const accommRsvPlanActions = {
  SET_RSV_VALUE: '@@accommRsv/SET_RSV_VALUE',
};
